import { Loader } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
